import { useMutation } from "@tanstack/react-query";
import { supabase, invokeFunction } from "@/integrations/supabase/client";

interface RunSalesReconciliationPayload {
  organisation_id: string;
  csv_import_job_id: string;
  /** Ledger source for SALES_DEDUCTION (e.g. shopify_csv_import). Must allow sales in registry. */
  source: string;
}

export interface RunSalesReconciliationSuccess {
  run_id: string;
  batch_id?: string;
  status: "completed" | "running" | "queued" | "failed";
  events_written: number;
  affected_products: number;
  skipped_rows: number;
  idempotent?: boolean;
}

async function invoke(payload: RunSalesReconciliationPayload): Promise<RunSalesReconciliationSuccess> {
  const { data, error } = await invokeFunction(supabase, "run-sales-reconciliation-v1", {
    body: payload,
  });

  if (error) {
    throw new Error(error.message || "Failed to run sales reconciliation");
  }
  if (!data?.success) {
    throw new Error(data?.error || "Failed to run sales reconciliation");
  }

  return data as RunSalesReconciliationSuccess;
}

export function useRunSalesReconciliation() {
  const run = useMutation({
    mutationFn: (payload: RunSalesReconciliationPayload) => invoke(payload),
  });

  return { run };
}
